/**
 * StudentLiveEntryScreen — l'avant-séance de l'élève (`pre-call`, poussée par « GO ! ») :
 * `<StudentLiveEntryPage>`, la salle d'attente du live, puis Sam en plein écran
 * (`<StudentStartingBlockPage>`) quand le starting block est prêt.
 *
 * Un fil : l'état (`useStudentLiveEntryState`), la barre, la séance et le matériel au second plan
 * (`liveEntryLobbyViewModel`), le flux de la caméra et l'étape ouverte du test (`StudentDeviceCheck`),
 * le choix du navigateur hors de Chrome. Le micro et la caméra se coupent sur l'image, au geste du
 * live. « Rejoindre » ouvre le live par `setIsLiveModeEnabled`. Pendant que le navigateur pose la
 * question du test, son guidage (`LivePermissionCoach`), comme dans le live.
 */
import React from "react"

import { StudentLiveEntryPage } from "../../../../../../design-system/student"
import { LivePermissionCoach } from "../Live/LivePermissionCoach"
import { type StudentSpaceScreenProps } from "../studentSpaceRouteTypes"
import { liveEntryBrowserChoice, liveEntryCheckProps } from "./liveEntryPageProps"
import { StudentStartingBlock } from "./StudentStartingBlock"
import { useStudentLiveEntryState } from "./useStudentLiveEntryState"

export function StudentLiveEntryScreen({ route }: StudentSpaceScreenProps) {
    const liveSessionId = String(route?.params?.liveSessionId ?? "0")
    const entry = useStudentLiveEntryState(liveSessionId)
    const { check, vm } = entry
    const { heading, status, equipment } = entry.lobby

    if (entry.startingBlock != null) {
        return (
            <StudentStartingBlock
                conversation={entry.startingBlock}
                liveSessionId={liveSessionId}
                onEnter={entry.joinSession}
            />
        )
    }

    return (
        <>
            <LivePermissionCoach tutorFirstname={entry.entry.session?.tutor.firstname} />
            <StudentLiveEntryPage
                heading={heading}
                status={status}
                present={entry.entry.present}
                presentLabel={entry.entry.presentLabel}
                {...liveEntryCheckProps({
                    equipment,
                    check,
                    vm,
                    testShown: entry.testShown,
                    releasing: entry.releasing,
                    mic: entry.mic,
                })}
                browserChoice={liveEntryBrowserChoice(entry.browser, entry.dismissBrowser)}
                entering={entry.entering}
                samWaiting={entry.samWaiting}
                joinReady={entry.lobby.join.ready}
                joinNote={entry.lobby.join.note}
                onEnter={entry.onEnter}
                onBack={entry.onBack}
            />
        </>
    )
}
